/**
 * Inline sample datasets for the 5 Disease Resistance analyses.
 * Pure in-memory JS — no external fetches.
 */

export const DISEASE_INLINE_SAMPLES = {
  // 1. AUDPC — 10 wheat genotypes × 5 dates (DAS), stripe rust 0-9 scale, 3 reps
  'disease-audpc': `Genotype,Date_or_DAS,Disease_score,Rep
HD2967,30,0,1
HD2967,30,0,2
HD2967,30,0,3
HD2967,45,1,1
HD2967,45,1,2
HD2967,45,2,3
HD2967,60,2,1
HD2967,60,3,2
HD2967,60,3,3
HD2967,75,3,1
HD2967,75,4,2
HD2967,75,4,3
HD2967,90,4,1
HD2967,90,5,2
HD2967,90,5,3
PBW343,30,0,1
PBW343,30,1,2
PBW343,30,0,3
PBW343,45,3,1
PBW343,45,3,2
PBW343,45,4,3
PBW343,60,5,1
PBW343,60,6,2
PBW343,60,6,3
PBW343,75,7,1
PBW343,75,7,2
PBW343,75,8,3
PBW343,90,8,1
PBW343,90,9,2
PBW343,90,9,3
DBW17,30,0,1
DBW17,30,0,2
DBW17,30,0,3
DBW17,45,1,1
DBW17,45,1,2
DBW17,45,1,3
DBW17,60,2,1
DBW17,60,2,2
DBW17,60,2,3
DBW17,75,2,1
DBW17,75,3,2
DBW17,75,3,3
DBW17,90,3,1
DBW17,90,3,2
DBW17,90,4,3
WH1105,30,0,1
WH1105,30,0,2
WH1105,30,0,3
WH1105,45,2,1
WH1105,45,2,2
WH1105,45,3,3
WH1105,60,4,1
WH1105,60,4,2
WH1105,60,5,3
WH1105,75,5,1
WH1105,75,6,2
WH1105,75,6,3
WH1105,90,7,1
WH1105,90,7,2
WH1105,90,8,3
HD3086,30,0,1
HD3086,30,0,2
HD3086,30,0,3
HD3086,45,1,1
HD3086,45,1,2
HD3086,45,2,3
HD3086,60,2,1
HD3086,60,3,2
HD3086,60,3,3
HD3086,75,4,1
HD3086,75,4,2
HD3086,75,5,3
HD3086,90,5,1
HD3086,90,6,2
HD3086,90,6,3
PBW725,30,0,1
PBW725,30,0,2
PBW725,30,0,3
PBW725,45,0,1
PBW725,45,1,2
PBW725,45,1,3
PBW725,60,1,1
PBW725,60,2,2
PBW725,60,2,3
PBW725,75,2,1
PBW725,75,3,2
PBW725,75,3,3
PBW725,90,3,1
PBW725,90,3,2
PBW725,90,4,3
UP2338,30,1,1
UP2338,30,1,2
UP2338,30,1,3
UP2338,45,3,1
UP2338,45,3,2
UP2338,45,4,3
UP2338,60,5,1
UP2338,60,6,2
UP2338,60,6,3
UP2338,75,7,1
UP2338,75,7,2
UP2338,75,8,3
UP2338,90,8,1
UP2338,90,9,2
UP2338,90,9,3
K0307,30,0,1
K0307,30,0,2
K0307,30,0,3
K0307,45,2,1
K0307,45,2,2
K0307,45,2,3
K0307,60,3,1
K0307,60,3,2
K0307,60,4,3
K0307,75,4,1
K0307,75,5,2
K0307,75,5,3
K0307,90,6,1
K0307,90,6,2
K0307,90,7,3
NW1014,30,0,1
NW1014,30,0,2
NW1014,30,0,3
NW1014,45,1,1
NW1014,45,1,2
NW1014,45,2,3
NW1014,60,2,1
NW1014,60,3,2
NW1014,60,3,3
NW1014,75,3,1
NW1014,75,4,2
NW1014,75,4,3
NW1014,90,4,1
NW1014,90,5,2
NW1014,90,5,3
VL907,30,0,1
VL907,30,0,2
VL907,30,0,3
VL907,45,0,1
VL907,45,1,2
VL907,45,1,3
VL907,60,1,1
VL907,60,1,2
VL907,60,2,3
VL907,75,2,1
VL907,75,2,2
VL907,75,2,3
VL907,90,2,1
VL907,90,3,2
VL907,90,3,3`,

  // 2. Infection Type — 5 wheat genotypes × 6 stripe-rust isolates
  'disease-infection-type': `Genotype,Isolate_or_Race,Infection_type,Count
HD2967,78S84,2,4
HD2967,46S119,3,3
HD2967,110S119,2,5
HD2967,6S63,1,5
HD2967,79S84,0;,5
HD2967,110S238,2,4
PBW343,78S84,4,5
PBW343,46S119,4,5
PBW343,110S119,3,4
PBW343,6S63,3,5
PBW343,79S84,4,4
PBW343,110S238,4,5
DBW17,78S84,0;,5
DBW17,46S119,0;,5
DBW17,110S119,1,4
DBW17,6S63,0;,5
DBW17,79S84,0;,5
DBW17,110S238,1,4
WH1105,78S84,3,4
WH1105,46S119,4,3
WH1105,110S119,4,5
WH1105,6S63,2,5
WH1105,79S84,3,4
WH1105,110S238,4,4
PBW725,78S84,1,5
PBW725,46S119,2,4
PBW725,110S119,1,5
PBW725,6S63,0;,5
PBW725,79S84,1,5
PBW725,110S238,2,4`,

  // 3. Disease-Yield Correlation — 25 plots at various severity levels
  'disease-yield-correlation': `Plot,Disease_severity_percent,Yield,Rep,Treatment
1,5,48.2,1,Untreated
2,8,46.5,2,Untreated
3,12,44.0,3,Untreated
4,15,42.1,1,Fungicide_low
5,18,41.0,2,Fungicide_low
6,22,38.5,3,Fungicide_low
7,25,36.8,1,Untreated
8,30,34.5,2,Untreated
9,35,31.8,3,Untreated
10,40,29.5,1,Fungicide_low
11,45,26.9,2,Fungicide_low
12,50,24.2,3,Fungicide_low
13,55,21.5,1,Untreated
14,60,18.8,2,Untreated
15,65,16.2,3,Untreated
16,70,13.5,1,Fungicide_low
17,75,11.0,2,Fungicide_low
18,80,8.5,3,Fungicide_low
19,3,49.1,1,Fungicide_high
20,6,47.8,2,Fungicide_high
21,9,46.0,3,Fungicide_high
22,2,49.5,1,Fungicide_high
23,4,48.7,2,Fungicide_high
24,7,47.0,3,Fungicide_high
25,10,45.2,1,Fungicide_high`,

  // 4. Virulence Frequency — 80 isolates × 8 differentials × 3 years
  'disease-virulence-frequency': `Isolate,Differential_host,Reaction,Year,Location
I01,Yr1,V,2022,Karnal
I01,Yr5,A,2022,Karnal
I01,Yr9,V,2022,Karnal
I01,Yr10,A,2022,Karnal
I01,Yr17,A,2022,Karnal
I01,Yr24,A,2022,Karnal
I01,Yr27,A,2022,Karnal
I01,YrA,V,2022,Karnal
I02,Yr1,V,2022,Karnal
I02,Yr5,A,2022,Karnal
I02,Yr9,V,2022,Karnal
I02,Yr10,V,2022,Karnal
I02,Yr17,A,2022,Karnal
I02,Yr24,A,2022,Karnal
I02,Yr27,A,2022,Karnal
I02,YrA,V,2022,Karnal
I03,Yr1,V,2022,Ludhiana
I03,Yr5,V,2022,Ludhiana
I03,Yr9,V,2022,Ludhiana
I03,Yr10,A,2022,Ludhiana
I03,Yr17,A,2022,Ludhiana
I03,Yr24,V,2022,Ludhiana
I03,Yr27,A,2022,Ludhiana
I03,YrA,V,2022,Ludhiana
I04,Yr1,V,2023,Karnal
I04,Yr5,V,2023,Karnal
I04,Yr9,V,2023,Karnal
I04,Yr10,V,2023,Karnal
I04,Yr17,V,2023,Karnal
I04,Yr24,A,2023,Karnal
I04,Yr27,A,2023,Karnal
I04,YrA,V,2023,Karnal
I05,Yr1,V,2023,Pune
I05,Yr5,V,2023,Pune
I05,Yr9,V,2023,Pune
I05,Yr10,V,2023,Pune
I05,Yr17,V,2023,Pune
I05,Yr24,V,2023,Pune
I05,Yr27,A,2023,Pune
I05,YrA,V,2023,Pune
I06,Yr1,V,2024,Ludhiana
I06,Yr5,V,2024,Ludhiana
I06,Yr9,V,2024,Ludhiana
I06,Yr10,V,2024,Ludhiana
I06,Yr17,V,2024,Ludhiana
I06,Yr24,V,2024,Ludhiana
I06,Yr27,V,2024,Ludhiana
I06,YrA,V,2024,Ludhiana
I07,Yr1,V,2024,Karnal
I07,Yr5,V,2024,Karnal
I07,Yr9,V,2024,Karnal
I07,Yr10,V,2024,Karnal
I07,Yr17,V,2024,Karnal
I07,Yr24,V,2024,Karnal
I07,Yr27,V,2024,Karnal
I07,YrA,V,2024,Karnal
I08,Yr1,A,2024,Delhi
I08,Yr5,A,2024,Delhi
I08,Yr9,V,2024,Delhi
I08,Yr10,A,2024,Delhi
I08,Yr17,A,2024,Delhi
I08,Yr24,A,2024,Delhi
I08,Yr27,A,2024,Delhi
I08,YrA,V,2024,Delhi
I09,Yr1,V,2024,Delhi
I09,Yr5,V,2024,Delhi
I09,Yr9,V,2024,Delhi
I09,Yr10,V,2024,Delhi
I09,Yr17,V,2024,Delhi
I09,Yr24,V,2024,Delhi
I09,Yr27,V,2024,Delhi
I09,YrA,V,2024,Delhi
I10,Yr1,V,2024,Pune
I10,Yr5,V,2024,Pune
I10,Yr9,V,2024,Pune
I10,Yr10,V,2024,Pune
I10,Yr17,V,2024,Pune
I10,Yr24,V,2024,Pune
I10,Yr27,A,2024,Pune
I10,YrA,V,2024,Pune`,

  // 5. Resistance Screening Summary — 8 genotypes × 4 environments × 2 diseases, 0-9 scale
  'disease-screening-summary': `Genotype,Location,Year,Disease,Score,Scale
HD2967,Karnal,2022,StripeRust,5,9
HD2967,Karnal,2023,StripeRust,4,9
HD2967,Ludhiana,2022,StripeRust,6,9
HD2967,Ludhiana,2023,StripeRust,5,9
HD2967,Karnal,2022,LeafRust,4,9
HD2967,Karnal,2023,LeafRust,3,9
HD2967,Ludhiana,2022,LeafRust,5,9
HD2967,Ludhiana,2023,LeafRust,4,9
PBW343,Karnal,2022,StripeRust,8,9
PBW343,Karnal,2023,StripeRust,9,9
PBW343,Ludhiana,2022,StripeRust,9,9
PBW343,Ludhiana,2023,StripeRust,8,9
PBW343,Karnal,2022,LeafRust,7,9
PBW343,Karnal,2023,LeafRust,8,9
PBW343,Ludhiana,2022,LeafRust,8,9
PBW343,Ludhiana,2023,LeafRust,7,9
DBW17,Karnal,2022,StripeRust,2,9
DBW17,Karnal,2023,StripeRust,2,9
DBW17,Ludhiana,2022,StripeRust,3,9
DBW17,Ludhiana,2023,StripeRust,2,9
DBW17,Karnal,2022,LeafRust,2,9
DBW17,Karnal,2023,LeafRust,1,9
DBW17,Ludhiana,2022,LeafRust,3,9
DBW17,Ludhiana,2023,LeafRust,2,9
WH1105,Karnal,2022,StripeRust,6,9
WH1105,Karnal,2023,StripeRust,7,9
WH1105,Ludhiana,2022,StripeRust,8,9
WH1105,Ludhiana,2023,StripeRust,7,9
WH1105,Karnal,2022,LeafRust,5,9
WH1105,Karnal,2023,LeafRust,6,9
WH1105,Ludhiana,2022,LeafRust,7,9
WH1105,Ludhiana,2023,LeafRust,6,9
PBW725,Karnal,2022,StripeRust,3,9
PBW725,Karnal,2023,StripeRust,2,9
PBW725,Ludhiana,2022,StripeRust,4,9
PBW725,Ludhiana,2023,StripeRust,3,9
PBW725,Karnal,2022,LeafRust,2,9
PBW725,Karnal,2023,LeafRust,3,9
PBW725,Ludhiana,2022,LeafRust,3,9
PBW725,Ludhiana,2023,LeafRust,2,9
HD3086,Karnal,2022,StripeRust,4,9
HD3086,Karnal,2023,StripeRust,5,9
HD3086,Ludhiana,2022,StripeRust,6,9
HD3086,Ludhiana,2023,StripeRust,5,9
HD3086,Karnal,2022,LeafRust,4,9
HD3086,Karnal,2023,LeafRust,5,9
HD3086,Ludhiana,2022,LeafRust,5,9
HD3086,Ludhiana,2023,LeafRust,4,9
VL907,Karnal,2022,StripeRust,1,9
VL907,Karnal,2023,StripeRust,2,9
VL907,Ludhiana,2022,StripeRust,2,9
VL907,Ludhiana,2023,StripeRust,1,9
VL907,Karnal,2022,LeafRust,1,9
VL907,Karnal,2023,LeafRust,2,9
VL907,Ludhiana,2022,LeafRust,2,9
VL907,Ludhiana,2023,LeafRust,1,9
NW1014,Karnal,2022,StripeRust,4,9
NW1014,Karnal,2023,StripeRust,3,9
NW1014,Ludhiana,2022,StripeRust,5,9
NW1014,Ludhiana,2023,StripeRust,4,9
NW1014,Karnal,2022,LeafRust,3,9
NW1014,Karnal,2023,LeafRust,4,9
NW1014,Ludhiana,2022,LeafRust,4,9
NW1014,Ludhiana,2023,LeafRust,3,9`,
};

export const DISEASE_SAMPLE_BANNERS = {
  'disease-audpc': 'Sample loaded — 10 wheat genotypes × 5 dates × 3 reps (stripe rust 0-9 scale) — Run Analysis!',
  'disease-infection-type': 'Sample loaded — 5 wheat genotypes × 6 stripe-rust isolates (Stakman 0-4 scale) — Run Analysis!',
  'disease-yield-correlation': 'Sample loaded — 25 plots with severity + yield + fungicide treatment — Run Analysis!',
  'disease-virulence-frequency': 'Sample loaded — 10 isolates × 8 differentials × 3 years — Run Analysis!',
  'disease-screening-summary': 'Sample loaded — 8 wheat genotypes × 2 locations × 2 years × 2 diseases — Run Analysis!',
};
